import { LoadScriptResolver } from './load-script.resolver';

export function LoadACMECheckoutResolver() {
  const hash = window.CONFIG.ACMETICKETING_CHECKOUT_SRI;
  const sri = hash ? { integrity: `sha384-${hash}`, crossOrigin: 'anonymous' } : {};

  return LoadScriptResolver({
    id: 'acme-checkout-js',
    url: window.CONFIG.ACMETICKETING_CHECKOUT_URL,
    ...sri,
  });
}
